import type { ReactNode } from 'react';
import { Children } from 'react';

import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import STYLES from './GridItem.module.scss';

import ResponsiveSquare from '@shared/ui/common/ResponsiveSquare';

type Props = {
  children: ReactNode;
  imageNumber: number;
};
const cls = cssModules(STYLES);

const GridItem = ({ children, imageNumber }: Props) => {
  const divs = Children.map(children, (child) => (
    <ResponsiveSquare
      className={cls('GridItem--item', `GridItem__${imageNumber}--item`)}
    >
      {child}
    </ResponsiveSquare>
  ));
  return (
    <div className={cls('GridItem', `GridItem__${imageNumber}`)}>{divs}</div>
  );
};

export default GridItem;
